import React from 'react';

import {connect} from 'react-redux';

import {Price} from 'components/price/price';
import {ApplicationStoreType} from 'desktop/store';

import {
    getIsShowTaxWarning,
    getIncludingTax,
    getOrderReviewTotals,
} from '../../store/selectors/orderReviewTotals/orderReviewTotals';

import s from './taxWarning.scss';

export type PropsType = {
    isShowTaxWarning: boolean;
    includingTax: number;
    grandTotal: number;
};

/**
 * Tax Warning for checkout
 *
 * @constructor
 */
export const TaxWarning: React.FC<PropsType> = ({grandTotal, includingTax, isShowTaxWarning}) => {
    if (!isShowTaxWarning) return null;

    return (
        <div className={s.taxWarning}>
            The subtotal for your order <span className={s.bold}>including tax</span> is{' '}
            <Price>{includingTax}</Price>. <br />
            Your discount was applied <br />
            However, we require a payment method due to the tax (Amount is{' '}
            <Price>{grandTotal}</Price>).
        </div>
    );
};

/**
 * Map state to props
 * @param {ApplicationStoreType} store - redux store
 * @returns {PropsType} props
 */
const mapStateToProps = (store: ApplicationStoreType) => ({
    grandTotal: getOrderReviewTotals(store).grandTotal,
    includingTax: getIncludingTax(store),
    isShowTaxWarning: getIsShowTaxWarning(store),
});

export const TaxWarningConnected = connect(mapStateToProps)(TaxWarning);
